module.exports = __webpack_public_path__ + "img/title.9720e133.gif";